import {
  CHECK_STATUS_REQUEST,
  CHECK_STATUS_SUCCESS,
  CHECK_STATUS_FAILURE,
  SEND_STATS_REQUEST,
  SEND_STATS_SUCCESS,
  SEND_STATS_FAILURE,
  SEND_STATS_OPTIMISTIC,
  SEND_STATS_ROLLBACK,
} from '../actions/actionsStatistic';

const initialState = {
  status: null,
  loading: false,
  error: null,
  sending: false,
  sendError: null,
  previousStatus: null,
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case CHECK_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case CHECK_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        status: payload,
      };

    case CHECK_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case SEND_STATS_OPTIMISTIC:
      return {
        ...state,
        previousStatus: state.status ? { ...state.status } : null,
        status: state.status
          ? {
            ...state.status,
            status: payload.accepted ? 1 : 0,
          }
          : state.status,
      };

    case SEND_STATS_REQUEST:
      return {
        ...state,
        sending: true,
        sendError: null,
      };

    case SEND_STATS_SUCCESS:
      return {
        ...state,
        sending: false,
        status: payload || state.status,
        previousStatus: null,
      };

    case SEND_STATS_FAILURE:
      return {
        ...state,
        sending: false,
        sendError: payload,
      };

    case SEND_STATS_ROLLBACK:
      return {
        ...state,
        status: state.previousStatus,
        previousStatus: null,
        sending: false,
      };

    default:
      return state;
  }
};
